import { useState } from 'react';
import { faqs } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

export default function Faq() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 border-t border-background-200/60">
      <div className="mx-auto w-full max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="常见问题"
          title="关于看料社，你可能想了解的"
          desc="整理了几个料友常问的问题，如果你还有其他疑问，欢迎在联系板块直接留言或发邮件咨询。"
          align="center"
        />

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = active === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200/80 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setActive(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-base font-bold text-foreground-950">{f.q}</span>
                  <i
                    className={`${isOpen ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-400'} text-xl transition-colors`}
                  ></i>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}